export default __webpack_public_path__ + "password_icon.fbb0f8.svg";